'use client'

import { ReactNode } from 'react'

type SmoothScrollLinkProps = {
  children: ReactNode
  targetId: string
  className?: string
  href?: string
}

export default function SmoothScrollLink({ children, targetId, className, href }: SmoothScrollLinkProps): JSX.Element {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault()
    const element = document.getElementById(targetId)
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      })
    }
  }

  return (
    <a href={href || `#${targetId}`} className={className} onClick={handleClick}>
      {children}
    </a>
  )
}
